import { render, staticRenderFns } from "./Buchung.vue?vue&type=template&id=243e8f84&"
import script from "./Buchung.vue?vue&type=script&lang=js&"
export * from "./Buchung.vue?vue&type=script&lang=js&"
import style0 from "./Buchung.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports